export default __webpack_public_path__ + "static/media/checkbox_on.4be38b22.svg";